let postsCount;
let totalPostCount;
let postsBankSize;
let postType;
const postsElement = document.getElementById('posts');
const loadMoreButton = document.getElementById('load-more');

// Initial render on page eload
document.addEventListener("DOMContentLoaded", function() {
    if( postsElement && typeof postsItems !== 'undefined' ){
        totalPostCount = postsItems.length;
        postsCount = Number(postsElement.dataset.initial);
        postsBankSize = Number(postsElement.dataset.bankSize);
        postType = postsElement.dataset.postType;
        console.log(`postType:${postType}`);
        postsElement.innerHTML = printCards();   
    }
}); 

// Render posts cards
const printCards = () => {
    setLoadMoreStatus(postsCount);
    return `
        ${postsItems.map((article, i) => {
            if( i < postsCount ){
                return cardHtml(article);
            }
        }).join('')}    
    `;
}

const cardHtml = (article) => {
    const title = article.post_title;
    let preHeading;
    let cta;
    let ctaColor = 'dodger-blue';

    switch(postType){
        case 'press':
            preHeading = article.fields.article_source;
            // cta = article.fields.article_link;
            cta = {
                'title' : 'Read More',
                'url' : article.permalink,
                'target' : '_self'
            };
        break;
        case 'post':
            cta = {
                'title' : 'Read More',
                'url' : article.permalink,
                'target' : '_self'
            };
            ctaColor = 'coral';
            break;
    }
    return (`
    <${ cta ? `a href="${cta.url}" target="${ cta.target != '' ? cta.target : '_self' }"` : `div`} class="cards__card cards__card--${postType}">
        <div class="cards__content">
        ${ typeof preHeading != 'undefined' ? `<h4 class="cards__pre_heading">${preHeading}</h4>` : ``}
        ${ title ? `<h3 class="cards__heading">${title}</h3>` : `` }
        </div>
        ${ cta ? `<span class="cards__cta button button--${ctaColor}">${cta.title}</span>` : ``}
    </${ cta ? `a` : `div`}>
    `);       
}

// Load more button and functionality
if(loadMoreButton){
    loadMoreButton.addEventListener('click', event => {
        postsCount += postsBankSize;
        postsElement.innerHTML = printCards();
    });
}

const setLoadMoreStatus = (postsCount) => {
    if (loadMoreButton) {
        if (postsCount < totalPostCount) {
            loadMoreButton.classList.add('load-more--active');
        } else {
            loadMoreButton.classList.remove('load-more--active');
        }
    }
}